export const getMenu = state => state.menuR.menu;
export const getMentionLegalesContent = state => state.mentionLegales.data;
export const getMentionLegalesLoading = state => state.mentionLegales.isLoading;